import React from 'react'
import { useState } from 'react'
import { ReactComponent as TickIcon} from '../../../images/icons/tick.svg'
import { ReactComponent as UpArrowIcon} from '../../../images/icons/upArrow.svg'
import { ReactComponent as DownArrowIcon} from '../../../images/icons/downArrow.svg'

const Mobiledropdown = ({Lable,SetValue,Value,Options}) => {
    const [drop,setDrop] = useState(false);
  return (
    <div className='filter_mobile_dropdown_container'>
      <button className={Value === "0" ? '': 'active'} onClick={()=>{setDrop(!drop)}}>
        <p>{Lable}</p>
        {drop &&
            <UpArrowIcon/>
        }
        {!drop &&
            <DownArrowIcon/>
        }
      </button>
      <div className={drop?'filter_mobile_dropdown_items active':'filter_mobile_dropdown_items'}>
        {
            Options.map((item,index)=>{
                return(
                    <div key={index} className={Value === item.name?'filter_mobile_dropdown_items_item active':'filter_mobile_dropdown_items_item'} onClick={()=>{SetValue(item.name);setDrop(false)}}>
                        <p>{item.name}</p>
                        {Value === item.name &&
                            <TickIcon/>
                        }
                    </div>
                )
            })
        }
      </div>
    </div>
  )
}

export default Mobiledropdown
